import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@mui/material';
import { LandingBackground } from '../../assets/images/landing-screen';

export const LandingPageContainer = styled(Grid)(() => ({
  backgroundImage: `url(${LandingBackground})`,
  backgroundSize: 'cover',
  position: 'relative',
  overflow: 'hidden',
  margin: 0,
  padding: 0,
  boxSizing: 'border-box',

  height: '98vh',
  width: '100%',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));

export const CocacolaTagImage = styled('img')({
  position: 'absolute',
  zIndex: 2,
  right: '2%',
  top: '4%',
});
export const TagImageBackground = styled('img')({
  position: 'absolute',
  zIndex: 1,
  right: '0%',
  top: '0%',
});

export const HeaderContainer = styled(Box)(() => ({
  position: 'absolute',
  top: '5%',
  left: '2%',
  display: 'flex',
  flexDirection: 'column',
}));

export const MainTitle = styled(Typography)(() => ({
  fontSize: '43.59px',
  fontWeight: 900,
  lineHeight: '53.14px',
  letterSpacing: '-3%',
}));

export const SubTitle = styled(Typography)(() => ({
  marginTop: '5px',

  fontWeight: 400,
  fontSize: '19.57px',
  lineHeight: '23.85px',
}));

export const ButtonsContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: '24%',
  right: '6%',
  display: 'flex',
  flexDirection: 'column',
}));

export const InteractiveButtons = styled(Button)(({ theme }) => ({
  backgroundColor: '#E61A27',
  color: 'white',
  borderRadius: '11px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  width: '100%',
  height: 'auto',
  border: 'none',
  cursor: 'pointer',
  textAlign: 'center',
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  textTransform: 'none',
  minWidth: '539px',
  minHeight: '80px',
  zIndex: 10,
  [theme.breakpoints.down('md')]: {
    width: '40%',
  },

  [theme.breakpoints.down('sm')]: {
    width: '80%',
  },
  '&:hover': {
    backgroundColor: '#E61A27',
    color: 'white',
  },
}));

export const InterativeBtnText = styled(Typography)(() => ({
  fontSize: 20,
  fontWeight: 600,
}));

export const MiscellaneousButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  marginTop: '3%',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const MiscellaneousButtons = styled(Button)(() => ({
  background: '#5B5B5B',
  width: '151px',
  height: '41px',
  color: 'white',
  borderRadius: '4px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  fontSize: '12px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#5B5B5B',
    color: 'white',
  },
}));

export const VersionContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: '4%',
  left: '3%',
}));

export const VersionText = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 700,
  color: '#8E8E93',
}));

export const ButtonIcon = styled('img')(() => ({
  marginRight: '10px',
  width: '27px',
  height: '27px',
}));

export const UserInfoContainer = styled(Grid)(() => ({
  display: 'flex',
  fontWeight: 700,
  fontSize: '12px',
  color: '#8E8E93',
  marginBottom: '15px',
}));

export const UserInfoText = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 600,
  lineHeight: '15.85px',
  color: 'rgba(142, 142, 147, 1)',
}));

export const CircleDot = styled('div')({
  marginLeft: '5px',
  marginRight: '5px',
  marginTop: '5px',
  width: '6px',
  height: '6px',
  backgroundColor: ' rgba(142, 142, 147, 1)',
  borderRadius: '50%',
});

export const LogoutButtons = styled(Button)(() => ({
  position: 'absolute',
  bottom: '4%',
  right: '4%',
  borderRadius: '7px',
  border: 'none',
  background: 'rgba(230, 26, 39, 0.13)',
  color: '#DF2020',
  width: '151px',
  height: '41px',
  textTransform: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  fontSize: '12px',
  fontWeight: 600,
  '&:hover': {
    background: 'rgba(230, 26, 39, 0.13)',
    color: '#DF2020',
  },
}));

export const HeaderDiv = styled('div')(() => ({
  background: '#E61A27',
  display: 'flex',
  justifyContent: 'space-between',
  height: '65px',
}));

export const HeaderDivContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  paddingLeft: '15px',
}));

export const HeaderTitle = styled(Typography)(() => ({
  paddingLeft: '15px',
  color: 'white',
  fontWeight: 600,
  fontSize: 20,
  lineHeight: '17.65px',
  letterSpacing: '1%',
}));

export const VideoContainer = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '2%',
  height: '380px',
  alignContent: 'center',
  alignItems: 'center',
}));

export const GuideBtnContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  alignContent: 'end',
  alignItems: 'end',
  marginRight: '22px',
  marginTop: '20px',
}));

export const GuideBtn = styled(Button)(() => ({
  background: '#7d7d7d',
  width: '133px',
  height: '39px',
  marginBottom: '10px',
  marginLeft: '10px',
  '&:hover': {
    background: '#E81C0E',
  },
}));

export const GuideBtnText = styled(Typography)(() => ({
  color: 'white',
  fontSize: '12px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  textTransform: 'none',
}));
